export default {
  storefront_not_found: {
    title: 'No storefront found',
    description: 'Please create a storefront.',
  },
};
